import { BodyDefault, HeadLine1, BodyMedium } from "../../../../components/typography/styled";
import Skeleton from 'react-loading-skeleton'
import styled, { useTheme } from "styled-components";

type StatusProp = {
  status?:string
}
type StatusBalance = {
  isRed?:boolean,
}
export const statusColor = (status?: string) => {
  switch (status) {
    case "unpaid":
      return "#E85048";
    case "suspended":
      return "#E85048";
    case "paid":
      return "#229B61";
    case "active":
      return "#229B61";
    default:
      return "";
  }
}

export const Container = styled.div`
  display:flex;
  flex-direction: column;
  gap:10px;
  min-width: 0;
`

export const TopBalanceWrapper = styled.div`
  display:flex;
  gap:10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

export const SubTitleText = styled(BodyDefault)`
  color:${({theme}) => theme.grey[700]};
`

export const InfoWrapper = styled.div`
  display:flex;
  flex-direction:column;
  gap:20px;
  align-items:flex-start;
  width: 100%;
  min-width: 0;
`

export const ButtonWrapper = styled.div`
  display:flex;
  gap:10px;
`

export const PriceTitle = styled(HeadLine1)<StatusBalance>`
  color:${({isRed, theme}) => isRed ? theme.errors[600] : ''};
  max-width: 100%;
  overflow-wrap: anywhere;
`

export const BalanceValueWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 0;
  min-width: 0;
  max-width: 100%;

  @media screen and (max-width:600px) {
    column-gap: 8px;
  }
`

export const StatusText = styled(BodyMedium)<StatusProp>`
  color: ${({status}) => statusColor(status)};
  text-transform:capitalize;
`

export const BodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  /* margin-top: 10px; */
  gap:10px;
`

export const RemainingContainer = styled.div`
  padding: 3px 4px;
  margin-left:10px;
  box-sizing:border-box;
  display: flex;
  flex-direction: row;
  gap:6px;
  align-items:center;
  background: ${({theme}) => theme.palette[200]};
  border-radius: 4px;

  @media screen and (max-width:600px) {
    max-width: 100%;
    margin-left: 0;
    overflow-wrap: anywhere;
  }
`
